export const label = 'Внутрішній номер відправлення';
export const maxLength = 50;
export const errors = {
  maxlength: `Максимальна довжина ${maxLength} символів`,
};
